import { render, staticRenderFns } from "./TransferDealModal.vue?vue&type=template&id=c822f3fe&"
import script from "./TransferDealModal.vue?vue&type=script&lang=js&"
export * from "./TransferDealModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports